import React from 'react';
import { IconProps } from '../names';

import qrcodeImageSrc from './qr.png';

export const QrCode = (props: IconProps) => (
  <img src={qrcodeImageSrc} {...props} alt="qr code" />
);
